import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { ValidationUtil } from '@app/common/util/validation.util';
import { AuthUtil } from '@app/common/util/auth.util';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { TranslateService } from '@ngx-translate/core';
import { ActionConstant } from '@app/common/constant/action-constant';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { setWAlert } from '@app/actions/w-alert.action';
import { CommonConstant } from '@app/common/constant/common.constant';

@Injectable({
    providedIn: 'root'
})
export class ProductService {

    constructor(private _http: HttpClient,
                private _translateService: TranslateService,
                private _wAlertStore: Store<WAlertState>,
		        private _router: Router,) { }

    loadTotalProduct(params: any): Observable<number> {
        let url = `${environment.apiUrl}/product/count`;
        return this._http.post<number>(url, params);
    }

    loadProducts(params: any): Observable<OrdPdtModel[]> {
        let url = `${environment.apiUrl}/product/search`;
        return this._http.post<OrdPdtModel[]>(url, params);
    }

    loadMainProducts(params: any): Observable<OrdPdtModel[]> {
        let url = `${environment.apiUrl}/product/main`;
        return this._http.post<OrdPdtModel[]>(url, params);
    }

    loadSpecialProducts(params: any): Observable<OrdPdtModel[]> {
        let url = `${environment.apiUrl}/product/special`;
        return this._http.post<OrdPdtModel[]>(url, params);
    }
	
	loadTotalSpecialProducts(params: any): Observable<number> {
        let url = `${environment.apiUrl}/product/special/count`;
        return this._http.post<number>(url, params);
    }

    getItemOfProduct(item: any, lShowPdtYn: string) {
		if (ValidationUtil.isNotNullAndNotEmpty(item.pdtCD)) {
			if (lShowPdtYn !== "Y" && !AuthUtil.isLogined()) {
				this._wAlertStore.dispatch(
					setWAlert({
						wAlert: {
							icon: WAlertConstant.confirm,
							message: this._translateService.instant('msgRequiredLogin'),
							action: ActionConstant.ACTION_CONFIRM_LOGIN
						}
					})
				);
			} else {
				let tmp: any = [];
				let pdtRecent: any = localStorage.getItem(CommonConstant.PRODUCT_RECENT);
				if (ValidationUtil.isNotNullAndNotEmpty(pdtRecent)) {
					tmp = JSON.parse(pdtRecent);
					let count = 0;
					for (let i = 0; i < tmp.length; i++) {
						if (item.pdtCD == tmp[i].pdtCD) {
							count++;
						}
					}

					if (count == 0) {
						if (tmp.length == 8) {
							tmp.splice(0, 1);
							tmp.push(item);
						} else {
							tmp.push(item);
						}
					}
				} else {
					tmp.push(item);
				}
				localStorage.setItem("pdtRecent", JSON.stringify(tmp));
				window.dispatchEvent(new Event('storage'));

				this._router.navigate([`/shopping-mall/product/${item.pdtCD}`]);
			}
		}
	}
}
